import React from "react"

import "./heading.scss"

const Heading = ({ title }) => <h2 className="page-title">{title}</h2>

export default Heading
